export { LpSettingsModule } from './lp-settings.module';
export { LpSettingsComponent } from './lp-settings.component';
